import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Pesquisa, PesquisaRespostaRequest } from '@gestor-web/@core/api/ords/model';
import { NotificationService } from '@gestor-web/app/shared/services';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PesquisaNpsDialogService {
  constructor(
    private simuladorGoApi: SimuladorGoApi,
    private notification: NotificationService,
  ) {}

  // Retorna a definição da pesquisa; null quando não existe (404) ou em erro,
  // para o modal simplesmente não exibir nada.
  fetchPesquisa(cdPesquisa: number, regans: string): Observable<Pesquisa | null> {
    return this.simuladorGoApi.fetchPesquisa(cdPesquisa, regans).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 404) {
          return of(null);
        }
        return this.notification.handleError(error);
      }),
    );
  }

  // Resolve com o cd_resposta gerado em caso de sucesso.
  saveResposta(cdPesquisa: number, regans: string, resposta: PesquisaRespostaRequest): Observable<number> {
    return this.simuladorGoApi.saveRespostaPesquisa(cdPesquisa, regans, resposta).pipe(
      map(response => response.cd_resposta),
      catchError((error: HttpErrorResponse) => this.notification.handleError(error)),
    );
  }
}
